export function convertToCurrentTimezone(date: Date): string {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric', month: 'numeric', day: 'numeric',
    hour: 'numeric', minute: 'numeric', second: 'numeric',
    timeZoneName: 'short'
  };

  return new Intl.DateTimeFormat('default', options).format(date);
}